import { useSearchFieldContext } from '../../context/SearchFieldContext';
import { FieldSearchOption } from '../../../../types';

export const useIsUserOption = () => {
  const { option } = useSearchFieldContext();
  return option === FieldSearchOption.UserProfile;
};
